import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/stores/store";
import Axios from "axios";

// Add public path
import '@/public-path.js'

// Import css
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "@/assets/css/ms-diagram.css";
import "@/assets/css/flexbox.css";
import "@/assets/css/common.css";
import "@/assets/scss/root.scss";
import "@/assets/scss/process-symbol.scss";
// localization
import i18n from "./i18ns/i18n";
// function and plugin
//import "./commons/msFormat"
import _cloneDeep from "lodash/cloneDeep";
import "./commons/prototype";
import moment from "moment";
import "@/commons/globalComponents.js";
import "@/commons/globalPlugin.js";
import "@/commons/msFormat.js";
import Popup from "./components/controls/ms-popup-notification";
import Permission from "./components/Permission/index.js";
import { _success, _error, _warning, _sendSalary } from "../src/views/Base/notify.js"
import {
  handleLocalize,
  handleValueLocalize,
  handleFieldLocalize
} from "/src/views/Setting/enums/convertLocalize.js";

import {
  convertToBase64,
  b64EncodeUnicode,
  b64DecodeUnicode
} from "/src/components/controls/ms-common/ms-position-apply/converBase64.js";

import webSocketInstance from "@/commons/web-socket.js"

Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();

Vue.prototype.$moment = moment;
Vue.prototype.$notify = {
  _success,
  _error,
  _warning,
  _sendSalary
};
Vue.prototype.$function = {
  _cloneDeep,
  handleLocalize,
  handleValueLocalize,
  handleFieldLocalize,
  b64DecodeUnicode,
  convertToBase64,
  b64EncodeUnicode
};
Vue.use(Permission);
Vue.use(Popup);
// store.dispatch('context/getContextData').then(() => {
//   new Vue({
//     router,
//     store,
//     i18n,
//     render: h => h(App)
//   }).$mount("#process-app-id")
// });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#process-app-id")

Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});
